export function useExpired() {
  const showExpried = useState('showExpried', () => false)
  const user = useUser()
  const { isLogin, isExpired } = useLogin()
  // 弹窗类型，1代表普通，2代表收藏，3代表导出，4代表达人导出 5代表详情次数 6：搜索次数
  const expriedType = useState('expriedType', () => 0)
  // 是否超过查看次数限制
  const isOverLimit = useState('isOverLimit', () => false)
  const isDetailForbidden = computed(() => {
    return !isLogin.value || isOverLimit.value
  })
  // const route = useRoute()
  // const noModals = route.meta.noModals
  function toggleExpried(val: boolean = false, type: number = 1) {
    const codeMap: Record<number, number> = {
      2: 2,
      3: 3,
      4: 4,
      40115: 5,
      40116: 6,
    }
    if (type === 40115) {
      isOverLimit.value = true // TODO: 后面通过接口控制，code为40115
    }
    expriedType.value = codeMap[type] || 1 // TODO: 后面通过接口控制，code为40115
    showExpried.value = val && expriedType.value !== 5 // 超过查看详情次数不弹窗
  }
  const tableMask = ref(false)
  watch(() => user.value?.info, () => {
    expriedType.value = 0
    isOverLimit.value = false
    showExpried.value = false
  })
  function toggleTableMask(code?: number) {
    tableMask.value = !code ? false : code >= 40100 && code <= 40119
  }
  return {
    showExpried,
    expriedType,
    isExpired,
    toggleExpried,
    tableMask,
    isOverLimit,
    isDetailForbidden,
    toggleTableMask,
  }
}
